import { Inject } from '@angular/core';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FileUpload } from 'src/app/services/file-upload.service';

@Component({
  selector: '[app-file]',
  templateUrl: './file.component.html',
  styleUrls: ['./file.component.scss']
})
export class FileComponent implements OnInit {

  @Input() file: FileUpload;
  @Input() disabled?: boolean;
  @Input() multiple?: boolean = false;
  @Input() borderless?: boolean;
  @Input() printMode?: boolean = false;
  @Input() showUser?: boolean = false;

  @Output() postEvent = new EventEmitter<FileList>();
  @Output() downloadEvent = new EventEmitter<FileUpload>();
  @Output() deleteEvent = new EventEmitter<number>();

  downloadUrl: string = "";
  constructor(@Inject('BASE_URL') private baseUrl: string) {}

  ngOnInit() {
    if (this.file) {
      this.downloadUrl = this.baseUrl + `filedownload/${this.file.fileUploadId}`;
      console.log(this.downloadUrl);
    }
  }

  postFile($event) {
    let files = $event.target.files;
    this.postEvent.emit(files);
  }

  downloadFile() {
    this.downloadEvent.emit(this.file);
  }

  deleteFile() {
    this.deleteEvent.emit(this.file.fileUploadId);
  }
}
